// WASPA 4.1.3: numeric claims must come from live data. Copy carries {tokens} filled from the brand's
// liveStats; a line with a token that has no value is dropped ('') rather than shown with a made-up number.
export default function liveCopy(text, stats = {}) {
  if (!text) return ''
  let unbound = false
  const filled = text.replace(/\{(\w+)\}/g, (_, key) => {
    const value = stats[key]
    if (value === null || value === undefined || value === '') unbound = true
    return unbound ? '' : String(value)
  })
  return unbound ? '' : filled
}
